import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import Loading from 'modules/core/components/Loading'
import Modal from 'modules/core/components/Modal'
import { useLazyRef } from 'modules/core/hooks/useLazyRef'
import i18n from 'modules/core/lib/i18n'

import useFetchManualIncidence from 'modules/payroll_bundle/hooks/useFetchManualIncidence'
import useUpdateManualIncidence from 'modules/payroll_bundle/hooks/useUpdateManualIncidence'
import ManualIncidenceForm from 'modules/payroll_bundle/pages/IncidencesPage/components/_ManualIncidenceModal/_Form'
import Form from 'modules/payroll_bundle/pages/IncidencesPage/utils/manualIncidenceForm'

interface Props {
  manualIncidenceId: number | string
  onClose: () => void
}

const Edit = ({ manualIncidenceId, onClose }: Props) => {
  const form = useLazyRef(() => new Form({})).current

  const { loading, manualIncidence } = useFetchManualIncidence(manualIncidenceId, form, onClose)

  const { loading: submitting, update: onSubmit } = useUpdateManualIncidence(
    manualIncidence,
    form,
    onClose
  )

  return (
    <Modal
      illustration="list-document"
      title={i18n.t('bookkeepers.incidence.manual.form.edit_title')}
      description={i18n.t('bookkeepers.incidence.manual.form.edit_description')}
      onClose={onClose}
      onSubmit={onSubmit}
      footer={
        <Button disabled={submitting} submit>
          {i18n.t('bookkeepers.incidence.manual.form.save')}
        </Button>
      }
    >
      {loading ? <Loading /> : <ManualIncidenceForm form={form} isEditing />}
    </Modal>
  )
}

export default Edit
